/*
 * Copyright (c) Dito Technologies LLC
 */

import {State} from "ui/feature/root/FormReducer";
import React from "react";
import {
    NoteSelectWorkspace_piece$data
} from "ui/feature/root/note-select/__generated__/NoteSelectWorkspace_piece.graphql";

export default function UsePollNoteFinderSteps(state: State, data: NoteSelectWorkspace_piece$data | null, retry: (() => void) | null) {

    const [shouldPoll, setShouldPoll] = React.useState<boolean>(true)

    React.useEffect(() => {
        if (!data) {
            console.log("no data");
            setShouldPoll(true);
            return;
        }
        const sheets = data.sheets;
        if (sheets) {
            for (const sheet of sheets) {
                if (!sheet.note_combine_steps) {
                    setShouldPoll(true);
                    return;
                }
                const step = sheet.note_combine_steps[0];
                if (step.status !== "SUCCESS") {
                    setShouldPoll(true)
                    return;
                }
            }
            setShouldPoll(false)
        } else {
            setShouldPoll(true);
            console.log("set should poll");
        }
    }, [data]);

    React.useEffect(() => {
        if (!state.pieceId || !shouldPoll) {
            return;
        }
        const interval = setInterval(() => {
            if (retry) {
                retry();
                console.log("retrying");
            }
        }, 5000);

        return () => {
            console.log("unsubscribing the user")
            clearInterval(interval)
        }

    }, [state.pieceId, shouldPoll, setShouldPoll, retry]);
}
